import React from 'react'
import { ContainerHeadingActionIcon, HeaderRow, HeaderCell,
  UnitsRow, UnitCell, DataRow, DataCell, Table, THead, TBody, DataTableModalContainer,
  TableContainer, DataTableFooter, DownloadButton } from './styled-elements'
import CloseCircle from '../icons/CloseCircle'
import ContainerHeading from '../layout/ContainerHeading'
import HelmetTitle from '../../components/layout/HelmetTitle'
import Moment from 'moment-timezone'
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect"

export default class DataTableCombined extends React.Component {

  componentDidMount = () => {
  }

  renderTable = (data) => {
    const colCount = data.headers[0].length
    const Row1 = data.headers && data.headers[0] && <HeaderRow key={0}>{data.headers[0].map((header, index) => <HeaderCell key={index} first={(index===0)}>{header}</HeaderCell>)}<HeaderCell key={colCount} /></HeaderRow>
    const Row2 = data.headers && data.headers[1] && <UnitsRow key={1}>{data.headers[1].map((unit, index) => <UnitCell key={index} first={(index===0)}>{unit}</UnitCell>)}<UnitCell key={colCount} /></UnitsRow>
    const Row3 = data.headers && data.headers[2] && <UnitsRow key={2}>{data.headers[2].map((unit, index) => <UnitCell key={index} first={(index===0)}>{unit}</UnitCell>)}<UnitCell  key={colCount} /></UnitsRow>
    const decimalPlacesArray = data.metadata && data.metadata.decimal_places
    const DataRows = data.data.map((row,rowIndex) => {
      const dateTimeIndex = data.headers[0].indexOf('Last Updated')
      const timezone_name = data.metadata.timezone ? data.metadata.timezone : row[data.headers[0].indexOf('Timezone')]
      const moment = Moment.tz(row[dateTimeIndex],timezone_name)
      const momentPart1 = moment.format('YYYY-MM-')
      const momentPart2 = moment.format('DD')
      const momentPart3 = moment.format('HH:mm')
      const dataCells = []
      for (let i=0;i<colCount;i++) {
        dataCells.push(row[i])
      }
      return <DataRow key={rowIndex}>
        {dataCells.map((value,cellIndex) => {
          if (cellIndex===0) {
            return <DataCell key={cellIndex} style={{ textAlign: 'left' }}>{value}</DataCell>
          } else if (cellIndex===dateTimeIndex) {
            return <DataCell key={cellIndex} style={{ maxWidth: 'unset' }}>{momentPart1}<strong>{momentPart2}</strong> | <strong>{momentPart3}</strong></DataCell>
          } else {
            return <DataCell key={cellIndex}>{value}</DataCell>
          }
	})}
        <DataCell key={colCount} />
      </DataRow>
    })
    return <Table>
      <THead>
        {Row1}
        {Row2}
        {Row3 && Row3}
      </THead>
      <TBody>
        {DataRows}
      </TBody>
    </Table>
  }

  renderDesktopFooter = (props) => <DataTableFooter>
    <DownloadButton variant="outlined" onClick={props.downloadAsClickHandler.bind(this,'xls')}>
      Download as XLS
    </DownloadButton>
  </DataTableFooter>

  renderBody = (props,state) => {
    if ( !props.data || !props.data.headers || !props.data.data ) return null
    const { dataView, data } = props
    const title = `${dataView.name}`
    return <DataTableModalContainer>
      <HelmetTitle title={title} />
      <ContainerHeading
        title={title}
        actionIcons={
          <ContainerHeadingActionIcon onClick={this.props.closeDataViewHandler}><CloseCircle /></ContainerHeadingActionIcon>
        }
      />
      <TableContainer>
        {this.renderTable(data)}
      </TableContainer>
        {isBrowser && (1==2) && this.renderDesktopFooter(props)}
    </DataTableModalContainer>
  }

  render = () => this.renderBody(this.props,this.state)

}



// WEBPACK FOOTER //
// ./src/components/dataViews/DataTableCombined.js